// extracted by mini-css-extract-plugin
export default {"label":"SelectOption_label__SK4+T","option":"SelectOption_option__Jqg6x"};